import React, { useEffect, useState } from "react";
import activityLogApi from "../../services/activityLogApi";
import DataTable from "../../components/common/DataTable";
import { useToast } from "../../components/common/Toast";
import "../../styles/target.css";
import "../../styles/adminGlobal.css";

const ACTIONS = [
  "TARGET_ASSIGNED",
  "TARGET_ACHIEVED",
  "TARGET_COMPLETED",
  "UPDATE",
  "DELETE",
];

/* =========================================================
   Admin: Activity Logs
   Read-only audit trail of every create/update/delete action
   across the system.
   GET /api/activity-logs?search=&user_id=&action=&module=&date_from=&date_to=&page=&limit=
========================================================= */
function ActivityLogs() {
  const toast = useToast();

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const limit = 20;

  const [search, setSearch] = useState("");
  const [action, setAction] = useState("");
  const [module, setModule] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, action, module, dateFrom, dateTo]);

  const fetchList = () => {
    setLoading(true);
    activityLogApi
      .getLogs({
        search: search || undefined,
        action: action || undefined,
        module: module || undefined,
        date_from: dateFrom || undefined,
        date_to: dateTo || undefined,
        page,
        limit,
      })
      .then((res) => {
        setRows(res.data.data || []);
        setTotal(res.data.total || 0);
      })
      .catch(() => toast.error("Failed to load activity logs"))
      .finally(() => setLoading(false));
  };

  const columns = [
    {
      key: "created_at",
      label: "Time",
      render: (r) => new Date(r.created_at).toLocaleString("en-IN"),
    },
    { key: "user_name", label: "User", render: (r) => r.user_name || "System" },
    { key: "role", label: "Role", render: (r) => r.role || "-" },
    {
      key: "action",
      label: "Action",
      render: (r) => <span className="action-badge">{r.action}</span>,
    },
    { key: "module", label: "Module" },
    { key: "description", label: "Description" },
  ];

  return (
    <div className="activity-logs-page">
      <div className="mytarget-header">
        <div>
          <h2>Activity Logs</h2>
          <p>Full audit trail of actions performed across the CRM</p>
        </div>
      </div>

      <div className="filters-bar">
        <input
          placeholder="Search user, description or module..."
          value={search}
          onChange={(e) => {
            setPage(1);
            setSearch(e.target.value);
          }}
        />
        <select
          value={action}
          onChange={(e) => {
            setPage(1);
            setAction(e.target.value);
          }}
        >
          <option value="">All actions</option>
          {ACTIONS.map((a) => (
            <option key={a} value={a}>
              {a}
            </option>
          ))}
        </select>
        <input
          placeholder="Module (e.g. Targets)"
          value={module}
          onChange={(e) => {
            setPage(1);
            setModule(e.target.value);
          }}
        />
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => {
            setPage(1);
            setDateFrom(e.target.value);
          }}
        />
        <input
          type="date"
          value={dateTo}
          onChange={(e) => {
            setPage(1);
            setDateTo(e.target.value);
          }}
        />
      </div>

      <DataTable
        columns={columns}
        data={rows}
        loading={loading}
        emptyIcon="🗒️"
        emptyText="No activity recorded"
        page={page}
        limit={limit}
        total={total}
        onPageChange={setPage}
      />
    </div>
  );
}

export default ActivityLogs;
